<template>
  <div id="education" class="pa-5">
    <v-layout wrap class="mb-5">
      <v-flex sm4 class="flex-center" :class="{'pr-5': $vuetify.breakpoint.smAndUp }">
        <div class="pf-bg-light-2">
          <img src="/static/logos/AU.png" width="100%" />
        </div>
      </v-flex>
      <v-flex sm4 class="flex-column">
        <span class="font-weight-400">Education</span>
        <span class="info-text pf-font-24 pf-text-teal font-weight-light">We cover a veriety of topics so you are well equipped to become adoptive parents.</span>
      </v-flex>
      <v-flex sm4 class="flex-center flex-column flex-end">
        <v-btn
          class="px-4 py-3 pf-btn-lg-plain pf-bg-teal"
          @click="gotoTraining"
          v-if="Account.lms_profile && Account.lms_profile.payment_status && Account.lms_profile.payment_status === 'Approved'"
        >
          Goto Training
        </v-btn>
        <template v-else>
          <span class="font-weight-bold pf-font-22">$ {{ formatPrice(amount) }}</span>
          <v-btn
            class="px-4 py-3 pf-btn-lg-plain pf-bg-teal"
            @click="purchase"
          >
            Purchase
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <v-layout>
      <p class="lh-22 font-weight-400 lp-2">Adoptive Parent Training course features professionals who, in short training sessions, present learning objectives for the most important steps through the adoption process. From the start in choosing adoption, through the home study to matching, hospital etiquette, post placement communication, and more, we cover a variety of topics so you are well equipped to become adoptive parents.</p>
    </v-layout>
    <v-layout>
      <v-list dense light>
        <v-list-tile class="no-hover-bg" v-for="(item, i) in listItems" :key="i">
          <v-list-tile-action>
            <v-icon size="16" class="pf-text-teal">square</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="lp-2 lh-22 pf-font-14 font-weight-400">{{ item }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-layout>
    <v-layout wrap class="py-5">
      <v-flex xs2>
        <v-btn
          class="px-4 py-3 pf-btn-lg-plain pf-bg-teal"
          @click="gotoTraining"
          v-if="Account.lms_profile && Account.lms_profile.payment_status && Account.lms_profile.payment_status === 'Approved'"
        >
          Goto Training
        </v-btn>
        <v-btn
          class="px-4 py-3 pf-btn-lg-plain pf-bg-teal"
          @click="purchase"
          v-else
        >
          Purchase
        </v-btn>
      </v-flex>
    </v-layout>
    <app-modal :active="showPurchasePopup" v-if="showPurchasePopup" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closePurchasePopup">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Purchase</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <v-form ref="checkoutForm">
              <v-layout wrap>
                <v-flex sm6>
                  <v-layout class="flex-column pl-3">
                    <span class="pf-font-16 font-weight-bold">Choose from your cards</span>
                    <v-flex class="flex-column listCard">
                      <v-radio-group v-model="selectedCardId" return-object :disabled="!!newCard.number">
                        <v-layout v-for="(card, i) in cards" :key="i">
                          <v-flex class="flex-center">
                            <v-radio
                              :value="card.id"
                              class="flex-center"
                            >
                              <template v-slot:label>
                                <div class="flex-center">
                                  <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                                  #### #### #### {{ card.number.substr(card.number.length - 4) }}
                                </div>
                              </template>
                            </v-radio>
                            <!-- <v-flex class="mb-2">
                              <v-btn icon class="ma-0" @click="deleteCard(card)" title="Delete">
                                <v-icon size="20" color="red">delete_outline</v-icon>
                              </v-btn>
                            </v-flex> -->
                          </v-flex>
                        </v-layout>
                        <p v-if="!cards.length">No saved cards found.</p>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm6>
                  <span class="pf-font-16 font-weight-bold">Use a new card</span>
                  <v-layout wrap>
                    <!-- Content -->
                    <v-flex xs12>
                      <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                        <template v-slot:prepend>
                          <v-fade-transition leave-absolute>
                            <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                          </v-fade-transition>
                        </template>
                      </v-text-field>
                      <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field v-model.trim="newCard.cvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="checkout"
            >
              Checkout
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="closePurchasePopup"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store config */
/* eslint complexity: ["error", 22] */
import { mapGetters } from 'vuex';
import { request, getCollection, getCardType } from '../helpers/helpers';
import swal from 'sweetalert2';
import AppModal from '../components/AppModal';
import { mask } from 'vue-the-mask';

export default {
  components: {
    'app-modal': AppModal,
  },
  directives: { mask },
  data: (vm) => ({
    listItems: [
      'In short training sessions, learn the ins and outs for the most important steps of the adoption process',
      'Learn at your own speed to best understand the material',
      'Interactive training ensures you are armed with the knowledge you need',
      'Quickly find adoption resources',
      'Discover adoption costs, laws, and processes',
      'Feel confident and prepared to navigate adoption',
      'Become Adoption U certified Adoptive Parents'
    ],
    showPurchasePopup: false,
    newCardNumber: '',
    newCardNumberMask: '',
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: '',
      cvv: ''
    },
    rules: {
      card: {
        // number: [v => !!v || 'Card number is required'],
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      }
    },
    selectedCardId: null,
    cards: [],
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
    amount: 125
  }),
  computed: {
    ...mapGetters([]),

    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
  },
  watch: {
  },
  async created () {
    /* Fetch the payment modes - Cards */
    await this.fetchPaymentModes();

    /* Set the card icon based on card type */
    this.setCardIcons();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async fetchPaymentModes () {
      if (!this.PaymentMode.length) {
        let where = { account: this.Account.id };
        let { error, data } = await getCollection('PaymentMode', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.PaymentMode = data;
            /* Set the local card variable */
            this.setCards();
          }
        }
      } else {
        this.setCards();
      }
    },
    setCardIcons () {
      this.cards = this.cards.map((x) => {
        let index = this.cardIcons.findIndex(y => y.type === x.type);
        if (x.type && index > -1) {
          x.icon = this.cardIcons[index].icon;
        }
        return x;
      });
    },
    formatPrice (value) {
      if (typeof value !== 'undefined') {
        let val = Number((value).toFixed(2)).toLocaleString();
        return val.indexOf('.') > -1 ? val : (val + '.00');
      }
    },
    purchase () {
      this.showPurchasePopup = true;
    },
    closePurchasePopup () {
      this.showPurchasePopup = false;
      this.newCardNumber = '';
      this.newCardNumberMask = '';
      this.newCard = {
        name: '',
        number: '',
        expiry: '',
        icon: 'credit-card.ico',
        type: '',
        cvv: ''
      };
    },
    newCardChange (newValue) {
      this.selectedCardId = null;
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    async checkout () {
      if (this.$refs.checkoutForm.validate()) {
        let payload = {
          account: this.Account.id,
          amount: this.amount
        };
        if (this.newCard) {
          payload.card = JSON.parse(JSON.stringify(this.newCard));
          delete payload.card.icon;
          delete payload.card.type;
          delete payload.card.name;
          /* format the card details */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.cvv = payload.card.cvv.replace(/ /g, '');

        } else if (this.selectedCardId) {
          payload.payment_mode = this.selectedCardId;
        } else {
          swal.fire({
            type: 'error',
            text: `You have to add or select the card to checkout`,
            showConfirmButton: true,
            timer: 2500
          });
        }

        window.getApp.$emit('LoadingText', 'Please wait.. We\'re processing your payment and enabling the course');
        let { error, data } = await request('Account/Moodle', 'POST', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            timer: 2500
          });
        } else if (data) {
          
          this.newCard = {
            name: '',
            number: '',
            expiry: '',
            icon: 'credit-card.ico',
            type: '',
            cvv: ''
          };
          this.selectedCardId = null;
          this.showPurchasePopup = false;
          /* Set the authorize_profile in account if not exists */
          if (data.lms_profile) {

            this.Account.lms_profile = data.lms_profile;

            if (data.lms_profile.payment_status !== 'Approved' || !data.lms_profile.payment) {
              swal.fire({
                type: 'error',
                title: 'Failed to process the request, please try again',
                showConfirmButton: false,
                timer: 2500
              });
            } else {
              swal.fire({
                type: 'success',
                title: 'Your transaction was processed. Now you can start the training, Good luck!',
                showConfirmButton: false,
                timer: 2500
              });
            }
          }
        } else {
          swal.fire({
            type: 'error',
            title: 'Failed to process the request, please try again',
            showConfirmButton: false,
            timer: 2500
          });
        }
        window.getApp.$emit('LoadingText', 'Loading');
      }
    },
    async gotoTraining () {
      if (this.Account.lms_profile && this.Account.lms_profile.payment && this.Account.lms_profile.payment_status === 'Approved') {
        let payload = {
          account: this.Account.id,
        };
        window.getApp.$emit('LoadingText', 'Requesting access to the course..');
        let { error, data } = await request('Account/Moodle/Training', 'POST', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            timer: 2500
          });
        } else if (data.username && data.password) {
          let courseUrl = `${config.moodle.login_url}?username=${data.username}&password=${data.password}`;
          swal.fire({
            type: 'success',
            title: `We're redirecting you to an external URL. Enjoy your learning!`,
            showConfirmButton: true,
            timer: 2500,
            onClose: () => {
              window.open(courseUrl);
            }
          });
        } else {
          swal.fire({
            type: 'error',
            title: 'Failed to process the request, please try again',
            showConfirmButton: false,
            timer: 2500
          });
        }
        window.getApp.$emit('LoadingText', 'Loading');
      }
    },
    setCards () {
      this.cards = this.PaymentMode.map(mode => {
        mode.card.icon = 'credit-card.ico';
        mode.card.id = mode.id;
        return mode.card;
      });
    },
  }
};
</script>
  
<style lang="css" scoped>
.listCard {
  height: 200px;
  overflow-y: scroll;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/Education.vue